export const SimilarChars =  {
  cyrillicChars: 'АВЕКМНОРСТУХ',
  latinChars: 'ABEKMHOPCTYX'
};